<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Latest Reporting Paerners Report</h5>
  </div>
  <div class="container" id="mainContent">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option  #item *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-sm-2">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
            View Report
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="excelExportLatestReportingPartnersReport()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container" id="mainContent">
    <div class="pt-2" *ngIf="latestReportingPartnersReport != null">
      <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">Latest Reporting Partners Report</span>
      </div>
      &nbsp;&nbsp;
      <ng-container *ngFor="let data of latestReportingPartnersReport">
       
          <div class="col-sm-4">
            <label class="col-form-label">
              <b>Branch :</b>
              {{ data.branch }}
            </label>
          </div>

          <div class="table-responsive" style="overflow-x:auto; margin-bottom:30px;">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Designation</th>
                  <th>Joining Date</th>
                  <th>Reporting Partner</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let detail of data.latestReortingPartnersRests; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ detail.name }}</td>
                  <td>{{ detail.type }}</td>
                  <td>{{ detail.designation }}</td>
                  <td>{{ detail.joiningDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.reportingPartner }}</td>
                  <td>{{ detail.startDate | date:'dd-MM-yyyy' }}</td>
                  <td>{{ detail.endDate | date:'dd-MM-yyyy' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
     </ng-container>
    </div>
  </div>
</div>